import { List, ListItem, Paper, Popper, styled } from '@mui/material';
import React, { useCallback, useRef, useState } from 'react';
import { getDateRangeFromMonths } from 'lib/SearchFilterUtil';
import DateRangePicker from 'components/commons/DateRangePicker';
import PropTypes from 'prop-types';

const StyledListItem = styled(ListItem, {
    shouldForwardProp: (prop) => prop !== 'selected'
})(({theme, selected}) => ({
    cursor: 'pointer',
    color: selected ? '#000000de' : '#0009'
}));

function OptionList(props) {
    const [sidePopperOpen, setSidePopperOpen] = useState(false);
    const buttonRef = useRef(null);

    React.useEffect(() => {
        setSidePopperOpen(props.isCustomDate);
    }, [props.isCustomDate]);

    const handleSelectionChange = useCallback((value) => {
        props.onSelect();
        props.onChange(value);
    }, [props.onSelect, props.onChange]);

    const handleOptionClick = useCallback((value) => {
        props.onSelect();
        props.onChange(getDateRangeFromMonths(value));
    }, [props.onSelect, props.onChange]);

    const handleButtonClick = useCallback(() => {
        setSidePopperOpen((open) => !open);
    }, []);

    return (
        <>
            <List>
                {props.options.map(option => {
                    const isActive = getDateRangeFromMonths(option.value) === props.value;
                    return (
                        <StyledListItem
                            button
                            key={option.value}
                            onClick={() => handleOptionClick(option.value)}
                            selected={Boolean(isActive)}
                        >
                            {option.label}
                        </StyledListItem>
                    );
                })}
                <StyledListItem
                    button
                    ref={buttonRef}
                    onClick={handleButtonClick}
                    selected={Boolean(props.isCustomDate)}
                >
                    Custom Date
                </StyledListItem>
            </List>
            <Popper
                open={sidePopperOpen}
                anchorEl={buttonRef.current}
                placement={!!props.displayRight ? 'right-end' : 'left-end'}
                style={{zIndex: 1300}}
                disablePortal
            >
                <Paper>
                    <DateRangePicker
                        value={props.value}
                        onSelectionChange={handleSelectionChange}
                        format={props.format}
                    />
                </Paper>
            </Popper>
        </>
    );
}

OptionList.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.number.isRequired,
        })
    ).isRequired,
    onChange: PropTypes.func.isRequired,
    onSelect: PropTypes.func,
    value: PropTypes.any,
    format: PropTypes.string,
    isCustomDate: PropTypes.bool.isRequired,
    displayRight: PropTypes.bool,
};

export default OptionList;